export default __webpack_public_path__ + "static/NotoSansThai-Regular.subset-687b1756429e8c2e192a14faa6e747e3.woff";